import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const AboutPage: React.FC = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col xs={12} md={8} lg={6}>
          <Card className="shadow-sm">
            <Card.Header>
              <h2 className="mb-0">🚀 About Pouncer</h2>
            </Card.Header>
            <Card.Body>
              <p className="lead">
                Welcome to Pouncer - your ultimate platform for securing the perfect phone numbers with Twilio integration!
              </p>
              
              <h5 className="mt-4 mb-3">🎯 Key Features:</h5>
              <ul className="list-group list-group-flush">
                <li className="list-group-item border-0 px-0">
                  <strong>� Smart Number Hunting:</strong> Pounce on specific numbers, prefixes, or area codes that matter to your business
                </li>
                <li className="list-group-item border-0 px-0">
                  <strong>🔔 Real-Time Notifications:</strong> Get instant alerts when your desired phone numbers become available
                </li>
                <li className="list-group-item border-0 px-0">
                  <strong>⚡ Automatic Twilio Integration:</strong> Seamlessly add new numbers directly to your Twilio account without manual intervention
                </li>
              </ul>
              
              <div className="mt-4 text-center">
                <img 
                  src="/spaghetti.png" 
                  alt="Pouncey eating spaghetti" 
                  className="img-fluid rounded mb-3"
                  style={{ maxWidth: '300px', height: 'auto' }}
                />
              </div>
              
              <div className="mt-3 p-3 bg-light rounded">
                <h6 className="mb-2">🍝 Meet Our Founder</h6>
                <p className="mb-0">
                  <strong>Mittens</strong> - Our visionary founder who created Pouncer while enjoying countless 
                  bowls of spaghetti. Mittens believes that great ideas, like great pasta, need the perfect 
                  sauce to bring them together. When not coding the next big feature, you'll find Mittens 
                  twirling linguine and dreaming up new ways to make text communication as satisfying as 
                  a perfectly al dente noodle.
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutPage;
